module.exports = __webpack_public_path__ + "img/143.62cdc72c.png";